import api from './api';

export const heroSlideService = {
  getSlides: async (params = {}) => {
    const response = await api.get('/hero-slides', { params });
    return response.data;
  },

  createSlide: async (payload) => {
    const response = await api.post('/hero-slides', payload);
    return response.data;
  },

  updateSlide: async (id, payload) => {
    const response = await api.put(`/hero-slides/${id}`, payload);
    return response.data;
  },

  deleteSlide: async (id) => {
    const response = await api.delete(`/hero-slides/${id}`);
    return response.data;
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);

    const response = await api.post('/hero-slides/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },
};

